import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const EXPIRATION_RULE_EDITOR_CLASS_NAME = 'ExpirationRuleEditor';
export const EXPIRATION_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type ExpirationRuleEditorClassSlot =
	(typeof EXPIRATION_RULE_EDITOR_CLASS_SLOTS)[number];

export interface ExpirationRuleEditorClasses {
	root: string;
}

export type ExpirationRuleEditorClassKey = keyof ExpirationRuleEditorClasses;

export const getExpirationRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(EXPIRATION_RULE_EDITOR_CLASS_NAME, slot);

export const expirationRuleEditorClasses: ExpirationRuleEditorClasses =
	generateUtilityClasses(EXPIRATION_RULE_EDITOR_CLASS_NAME, ['root']);

export default expirationRuleEditorClasses;
